import * as DOM from './utils';

export default function addDisplayLayerTransparency(layerGroup, transparencyContainer, displayLayerContainer) {
    const transparencyFragment = document.createDocumentFragment();

    const selection = [
        { value: 0, text: '100%' },
        { value: 0.25, text: '75%' },
        { value: 0.50, text: '50%' },
        { value: 0.75, text: '25%' },
        { value: 1, text: 'Off' },
    ];

    const heading = DOM.createElement('span', { class: 'heading' });
    heading.innerText = 'Gennemsigtighed';
    transparencyFragment.appendChild(heading);

    selection.forEach((transEl) => {
        const div = DOM.createElement('div', { class: 'transparency', value: transEl.value });
        if (this.config.initialDisplayLayerOpacity === transEl.value) { div.classList.add('selected'); }
        const text = DOM.createElement('span');
        text.innerText = transEl.text;
        div.appendChild(text);
        transparencyFragment.appendChild(div);
    });

    transparencyContainer.addEventListener('click', (e) => {
        if (e.target) {
            let el;
            if (e.target.classList.contains('transparency')) {
                el = e.target;
            } else if (e.target.parentElement.classList.contains('transparency')) {
                el = e.target.parentElement;
            } else {
                return;
            }

            const value = Number(el.getAttribute('value'));

            this.config.initialDisplayLayerOpacity = value;
            const icons = displayLayerContainer.querySelectorAll('.layerIcon');
            for (let i = 0; i < icons.length; i += 1) { icons[i].style.opacity = value; }

            DOM.clearClass(transparencyContainer, 'selected');
            el.classList.add('selected');
            layerGroup.eachLayer((layer) => {
                if (layer.options.pointToLayer) {
                    layer.setStyle({ fillOpacity: value });
                } else {
                    layer.setOpacity(value);
                }
            });
        }
    });

    transparencyContainer.appendChild(transparencyFragment);
}
